import { InfoAlert } from '@/components/alerts';
import { CompactButton, StandardButton } from '@/components/buttons';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex, Title } from '@mantine/core';
import { IconRosetteDiscountCheck, IconX } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { AccordionLocation } from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const AboutSubscriptionsPage = () => {
	const navigate = useNavigate();

	const closeButton = useMemo(
		() => (
			<CompactButton leftSection={<IconX />} onClick={() => navigate({ to: '/home' })}>
				Close
			</CompactButton>
		),
		[navigate]
	);

	const chooseSubscriptionButton = useMemo(
		() => (
			<StandardButton onClick={() => navigate({ to: '/choose-subscription' })}>
				Continue to Subscriptions
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Subscriptions', children: closeButton }}
			footer={{ children: chooseSubscriptionButton }}
		>
			<ContentPanel>
				<InfoAlert
					classNames={{ title: styles.alertTitle }}
					icon={<IconRosetteDiscountCheck />}
					title="Thank you for creating an account!"
					w="100%"
				/>
				<Flex direction="column" gap="lg" mb="lg" mt="lg">
					<Title order={1} className={styles.title}>
						About Curby Subscriptions.
					</Title>
				</Flex>
				<CurbyAccordion accordionLocation={AccordionLocation.AboutSubscriptions} />
			</ContentPanel>
		</PrimaryLayout>
	);
};
